<template>
  <div
    class="z-50 pointer-events-none"
    :class="[fixed ? 'fixed bottom-4 left-0 right-0 ' : '']"
  >
    <div
      class="w-full xl:max-w-screen-xl lg:max-w-screen-lg md:max-w-screen-md mx-auto pointer-events-auto"
    >
      <div
        v-if="buttonType === 'normal' || typeof buttonType === undefined"
        class="flex justify-end"
      >
        <button
          class="flex items-center border border-mid-grey rounded-full text-sm font-medium transition-colors bg-bkk-50"
          :class="[
            disabled ? 'cursor-not-allowed bg-lightest-gray' : 'bg-bkk-50',
          ]"
        >
          <div
            class="mr-2 flex flex-row justify-between w-full text-medium items-center px-4 py-1 pr-0"
          >
            {{ label }}
            <component :is="icon" class="h-7 w-7 ml-2" />
          </div>
        </button>
      </div>
      <div v-else-if="buttonType == 'white-inner'" class="flex justify-end">
        <button
          class="flex items-center border border-mid-grey rounded-full text-sm font-medium transition-colors bg-bkk-50"
          :class="[
            disabled ? 'cursor-not-allowed bg-lightest-gray' : 'bg-bkk-50',
          ]"
        >
          <div class="border-8 border-bkk-50 rounded-full hover:border-bkk-100">
            <div
              class="mr-2 flex flex-row justify-between w-full text-medium items-center px-4 py-1 pr-0 bg-white rounded-full border-light-gray border"
            >
              {{ label }}
              <component :is="icon" class="h-7 w-7 ml-2" />
            </div>
          </div>
        </button>
      </div>
      <div
        v-else-if="buttonType === 'rounded'"
        class="flex justify-end"
        :class="[rightPosition ? rightPosition : '']"
      >
        <button
          class="flex items-center border border-mid-grey rounded-full text-sm font-medium transition-colors p-2"
          :class="[disabled ? 'cursor-not-allowed bg-bkk-10' : 'bg-bkk-50']"
        >
          <component
            :is="icon"
            class="h-7 w-7"
            :class="[disabled ? 'opacity-25' : '']"
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps } from "vue";

defineProps<{
  label?: string;
  icon: any;
  disabled?: boolean;
  buttonType?: "normal" | "rounded" | "white-inner";
  rightPosition?: string;
  fixed: boolean;
}>();
</script>
